import { Link, useHistory } from "react-router-dom";
import ActionLayout from "components/events/EventDetail/ActionPanel/components/ActionLayout";
import ActuatorActionIcon from "assets/svg/event-action-actuator.svg";

type ActuatorActionProps = {
    eventId: string;
    actionId: string;
    showDeleteConfirm: any;
    actuatorName: string;
    actuatorType: string;
    actuatorMode: string;
    actuatorControl: string;
    action: any;
    checkEditable: any;
};

const ActuatorAction = ({
    eventId,
    actionId,
    showDeleteConfirm,
    actuatorName,
    actuatorType,
    actuatorMode,
    actuatorControl,
    action,
    checkEditable,
}: ActuatorActionProps) => {
    const history = useHistory();
    const isFourWireApp = !!action.fourWireApp;

    const getActuatorAction = () => {
        if (isFourWireApp) {
            const polarity = action.resource.polarity
                ? "Forward"
                : "Reverse";
            return action.resource.status === "off"
                ? "Pause"
                : polarity;
        }

        return action.resource.status === "off" ? "Deactivate" : "Activate";
    };

    const renderActuatorContent = () => {
        if (!actuatorName) {
            return (
                <span className="warning-message actuator">
                    <i className="material-icons outlined">error_outline</i>
                    <span>This Actuator is not found</span>
                </span>
            );
        }

        return (
            <>
                <Link
                    to={{
                        pathname: `/event-details/${eventId}/action/actuator/${actionId}`,
                    }}
                    onClick={checkEditable}
                >
                    <p className="mt-2 mb-3 default-white-color">Actuator</p>
                </Link>
                <p className="default-white-color mb-2">{actuatorName}</p>
                <p className="mb-2">{actuatorType}</p>
                {!isFourWireApp && actuatorMode && (
                    <p className="mb-2">
                        <span className="default-white-color">Mode: </span>
                        {actuatorMode}
                    </p>
                )}
                <p className="mb-2">
                    <span className="default-white-color">Control: </span>
                    {actuatorControl}
                </p>
                <p className="default-white-color mb-2">
                    Action: {getActuatorAction()}
                </p>

                {actuatorControl?.toLowerCase() === "manual" && (
                    <span className="warning-message actuator">
                        <i className="material-icons outlined">error_outline</i>
                        <span>This Actuator control changed into Manual</span>
                    </span>
                )}
            </>
        );
    };

    const renderActionIcon = () => {
        return <img src={ActuatorActionIcon} alt="action-actuator-icon" />;
    };

    return (
        <ActionLayout
            showDeleteConfirm={showDeleteConfirm}
            editAction={(e) => {
                const isEditable = checkEditable(e);
                if (isEditable) {
                    history.push(
                        `/event-details/${eventId}/action/actuator/${actionId}`
                    );
                }
            }}
            renderActionIcon={renderActionIcon}
        >
            {renderActuatorContent()}
        </ActionLayout>
    );
};

export default ActuatorAction;
